import React from 'react';
export function LocationsServed() {
  const locations = ['Madison', 'Ridgeland', 'Jackson', 'Gluckstadt', 'Flowood', 'Canton'];
  return <section className="py-16 md:py-24 bg-brand-locations text-center" data-id="element-170">
      <div className="container mx-auto px-6 md:px-8 max-w-4xl" data-id="element-171">
        <div className="text-brand-teal text-sm font-bold tracking-widest uppercase mb-4" data-id="element-172">
          Where We Work
        </div>

        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-text mb-10" data-id="element-173">
          Serving Madison & Surrounding Areas.
        </h2>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-10" data-id="element-174">
          {locations.map((location, index) => <div key={index} className="px-5 py-2.5 rounded-full border border-brand-teal text-brand-teal font-medium bg-white/50 shadow-sm" data-id="element-175">
              {location}
            </div>)}
        </div>

        <p className="text-lg text-brand-muted mb-8" data-id="element-176">
          Not sure if we cover your area? Reach out, we'll let you know.
        </p>

        <a href="#contact" className="inline-flex border-2 border-brand-teal text-brand-teal px-8 py-4 rounded-full font-semibold hover:bg-brand-teal/5 transition-colors min-h-[48px] items-center justify-center w-full sm:w-auto" data-id="element-177">
          Check Your Address
        </a>
      </div>
    </section>;
}